import {
    ACTIVE_STEP_SET,
    ASSET_ADD_ERROR,
    ASSET_ADD_IN_PROGRESS,
    ASSET_ADD_SUCCESS,
    ASSET_CARDS_FETCH_ERROR,
    ASSET_CARDS_FETCH_IN_PROGRESS,
    ASSET_CARDS_FETCH_SUCCESS,
    ASSET_DELETE_ERROR,
    ASSET_DELETE_IN_PROGRESS,
    ASSET_DELETE_SUCCESS,
    ASSET_FETCH_ERROR,
    ASSET_FETCH_IN_PROGRESS,
    ASSET_FETCH_SUCCESS,
    ASSET_TITLE_SET,
    ASSET_UPDATE_ERROR,
    ASSET_UPDATE_IN_PROGRESS,
    ASSET_UPDATE_SUCCESS,
    ASSET_UPLOAD_CANCEL_SET,
    ASSET_UPLOAD_ERROR,
    ASSET_UPLOAD_IN_PROGRESS,
    ASSET_UPLOAD_PROGRESS_SET,
    ASSET_UPLOAD_SET,
    ASSET_UPLOAD_SUCCESS,
    AVATAR_UPLOAD_ERROR,
    AVATAR_UPLOAD_IN_PROGRESS,
    AVATAR_UPLOAD_SUCCESS,
    BULK_MINT_SET,
    CATEGORY_SET,
    COLLECTION_SET,
    CREATE_COLLECTION_ACTIVE_STEP_SET,
    CREATE_COLLECTION_DESCRIPTION_SET,
    CREATE_COLLECTION_DIALOG_HIDE,
    CREATE_COLLECTION_DIALOG_SHOW,
    CREATE_COLLECTION_IMAGE_URL_SET,
    CREATE_COLLECTION_JSON_SCHEMA_SET,
    CREATE_COLLECTION_NAME_SET,
    CREATE_COLLECTION_SYMBOL_SET,
    DATE_DIALOG_HIDE,
    DATE_DIALOG_SHOW,
    DATE_RANGE_SET,
    DESCRIPTION_SET,
    END_DATE_SET,
    END_TIME_SET,
    EXTENSIBLE_STATUS_SET,
    MEDIA_URL_SET,
    MINT_COUNT_SET,
    MINT_COUNT_TAB_SET,
    MULTIPLE_MINT_TAB_SET,
    NSFW_STATUS_SET,
    PLAYER_SET,
    PREVIEW_DIALOG_HIDE,
    PREVIEW_DIALOG_SHOW,
    PREVIEW_URL_SET,
    RECIEPENT_ADDRESS_STATUS_SET,
    RECIPIENT_ADDRESS_SET,
    ROYALTY_SHARE_SET,
    ROYALTY_SHARE_STATUS_SET,
    SCHEMA_FETCH_ERROR,
    SCHEMA_FETCH_IN_PROGRESS,
    SCHEMA_FETCH_SUCCESS,
    SCHEMA_SET,
    SCHEMA_VALUES_SET,
    SOURCE_TYPE_SET,
    START_DATE_SET,
    START_TIME_SET,
    SUFFIX_COUNT_SET,
    SUFFIX_VALUE_SET,
    TAGS_FETCH_ERROR,
    TAGS_FETCH_IN_PROGRESS,
    TAGS_FETCH_SUCCESS,
    TAGS_SET,
    TOKEN_PRICE_SET,
    TOKEN_VALUE_SET,
    TRANSFER_STATUS_SET,
    TWEET_ID_SET,
    UPLOAD_FILE_CANCEL_SET,
    UPLOAD_FILE_ERROR_MESSAGE_SET,
    UPLOAD_FILES_DIALOG_HIDE,
    UPLOAD_FILES_DIALOG_SHOW,
} from '../../constants/createAssets';
import Axios from 'axios';
import {
    ADD_ASSETS_URL,
    ASSET_CARDS_URL,
    AVATAR_UPLOAD_URL,
    SCHEMA_LIST_URL,
    TAGS_URL,
    urlAssetFetch,
    urlReUploadAsset,
    urlUploadAsset,
} from '../../constants/url';
import { getAssetType } from '../../utils/strings';
import { handleErrorMessage } from '../../utils/errorMessages';

export const setActiveStep = (step) => {
    return {
        type: ACTIVE_STEP_SET,
        step,
    };
};

export const setAssetTitle = (value, valid) => {
    return {
        type: ASSET_TITLE_SET,
        value,
        valid,
    };
};

export const setSourceType = (value, valid) => {
    return {
        type: SOURCE_TYPE_SET,
        value,
        valid,
    };
};

export const setTweetID = (value, valid) => {
    return {
        type: TWEET_ID_SET,
        value,
        valid,
    };
};

export const setCategory = (value, valid) => {
    return {
        type: CATEGORY_SET,
        value,
        valid,
    };
};

export const setDescription = (value, valid) => {
    return {
        type: DESCRIPTION_SET,
        value,
        valid,
    };
};

export const setTags = (value) => {
    return {
        type: TAGS_SET,
        value,
    };
};

export const setCollection = (value) => {
    return {
        type: COLLECTION_SET,
        value,
    };
};

export const setRecipientAddress = (value) => {
    return {
        type: RECIPIENT_ADDRESS_SET,
        value,
    };
};

export const setTokenValue = (value) => {
    return {
        type: TOKEN_VALUE_SET,
        value,
    };
};

export const setTokenPrice = (value) => {
    return {
        type: TOKEN_PRICE_SET,
        value,
    };
};

export const setReciepentAddressStatus = (value) => {
    return {
        type: RECIEPENT_ADDRESS_STATUS_SET,
        value,
    };
};

export const showDateDialog = (value) => {
    return {
        type: DATE_DIALOG_SHOW,
        value,
    };
};

export const hideDateDialog = () => {
    return {
        type: DATE_DIALOG_HIDE,
    };
};

export const setDateRange = (value) => {
    return {
        type: DATE_RANGE_SET,
        value,
    };
};

export const setStartDate = (value) => {
    return {
        type: START_DATE_SET,
        value,
    };
};

export const setEndDate = (value) => {
    return {
        type: END_DATE_SET,
        value,
    };
};

export const setStartTime = (value) => {
    return {
        type: START_TIME_SET,
        value,
    };
};

export const setEndTime = (value) => {
    return {
        type: END_TIME_SET,
        value,
    };
};

export const setPlayer = (value) => {
    return {
        type: PLAYER_SET,
        value,
    };
};

export const showPreviewDialog = (value, from, data) => {
    return {
        type: PREVIEW_DIALOG_SHOW,
        value,
        from,
        data,
    };
};

export const hidePreviewDialog = () => {
    return {
        type: PREVIEW_DIALOG_HIDE,
    };
};

export const showCreateCollectionDialog = (value) => {
    return {
        type: CREATE_COLLECTION_DIALOG_SHOW,
        value,
    };
};

export const hideCreateCollectionDialog = () => {
    return {
        type: CREATE_COLLECTION_DIALOG_HIDE,
    };
};

export const setCollectionName = (value) => {
    return {
        type: CREATE_COLLECTION_NAME_SET,
        value,
    };
};

export const setCollectionSymbol = (value) => {
    return {
        type: CREATE_COLLECTION_SYMBOL_SET,
        value,
    };
};

export const setCollectionDescription = (value, valid) => {
    return {
        type: CREATE_COLLECTION_DESCRIPTION_SET,
        value,
        valid,
    };
};

export const setCollectionJsonSchema = (value, valid) => {
    return {
        type: CREATE_COLLECTION_JSON_SCHEMA_SET,
        value,
        valid,
    };
};

export const setCreateCollectionActiveStep = (step) => {
    return {
        type: CREATE_COLLECTION_ACTIVE_STEP_SET,
        step,
    };
};

export const setCollectionImageUrl = (value) => {
    return {
        type: CREATE_COLLECTION_IMAGE_URL_SET,
        value,
    };
};

export const setTransferStatus = (value) => {
    return {
        type: TRANSFER_STATUS_SET,
        value,
    };
};

export const setExtensibleStatus = (value) => {
    return {
        type: EXTENSIBLE_STATUS_SET,
        value,
    };
};

export const setNsfwStatus = (value) => {
    return {
        type: NSFW_STATUS_SET,
        value,
    };
};

export const setRoyaltyShareStatus = (value) => {
    return {
        type: ROYALTY_SHARE_STATUS_SET,
        value,
    };
};

export const setRoyaltyShare = (value) => {
    return {
        type: ROYALTY_SHARE_SET,
        value,
    };
};

export const setSchemaValues = (value, valid) => {
    return {
        type: SCHEMA_VALUES_SET,
        value,
        valid,
    };
};

export const setBulkMint = (show) => {
    return {
        type: BULK_MINT_SET,
        show,
    };
};

export const setMintCountTab = (value) => {
    return {
        type: MINT_COUNT_TAB_SET,
        value,
    };
};

export const setMintCount = (value) => {
    return {
        type: MINT_COUNT_SET,
        value,
    };
};

export const setMultipleMintTab = (value) => {
    return {
        type: MULTIPLE_MINT_TAB_SET,
        value,
    };
};

export const setSuffixValue = (value) => {
    return {
        type: SUFFIX_VALUE_SET,
        value,
    };
};

export const setSuffixCount = (value, valid) => {
    return {
        type: SUFFIX_COUNT_SET,
        value,
        valid,
    };
};

export const setMediaURL = (value) => {
    return {
        type: MEDIA_URL_SET,
        value,
    };
};

export const setPreviewURL = (value) => {
    return {
        type: PREVIEW_URL_SET,
        value,
    };
};

const addAssetInProgress = () => {
    return {
        type: ASSET_ADD_IN_PROGRESS,
    };
};

const addAssetSuccess = (value, message) => {
    return {
        type: ASSET_ADD_SUCCESS,
        value,
        message,
        variant: 'success',
    };
};

const addAssetError = (message) => {
    return {
        type: ASSET_ADD_ERROR,
        message,
        variant: 'error',
    };
};

export const addAsset = (data, cb) => (dispatch) => {
    dispatch(addAssetInProgress());

    Axios.post(ADD_ASSETS_URL, data, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem('acToken_of_studio'),
        },
    })
        .then((res) => {
            dispatch(addAssetSuccess(res.data && res.data.result, 'Asset Added Successfully'));
            cb(res.data && res.data.result);
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(addAssetError(message));

            cb(null);
        });
};

const updateAssetInProgress = () => {
    return {
        type: ASSET_UPDATE_IN_PROGRESS,
    };
};

const updateAssetSuccess = (value, message) => {
    return {
        type: ASSET_UPDATE_SUCCESS,
        value,
        message,
        variant: 'success',
    };
};

const updateAssetError = (message) => {
    return {
        type: ASSET_UPDATE_ERROR,
        message,
        variant: 'error',
    };
};

export const updateAsset = (id, data, cb) => (dispatch) => {
    dispatch(updateAssetInProgress());

    const url = urlAssetFetch(id);
    Axios.put(url, data, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem('acToken_of_studio'),
        },
    })
        .then((res) => {
            dispatch(updateAssetSuccess(res.data && res.data.result, 'Asset Updated Successfully'));
            cb(null);
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(updateAssetError(message));

            cb(error);
        });
};

const fetchAssetInProgress = () => {
    return {
        type: ASSET_FETCH_IN_PROGRESS,
    };
};

const fetchAssetSuccess = (value) => {
    return {
        type: ASSET_FETCH_SUCCESS,
        value,
    };
};

const fetchAssetError = (message) => {
    return {
        type: ASSET_FETCH_ERROR,
        message,
        variant: 'error',
    };
};

export const fetchAsset = (id, cb) => (dispatch) => {
    dispatch(fetchAssetInProgress());

    const url = urlAssetFetch(id);
    Axios.get(url, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem('acToken_of_studio'),
        },
    })
        .then((res) => {
            dispatch(fetchAssetSuccess(res.data && res.data.result));
            if (cb) {
                cb(res.data && res.data.result);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchAssetError(message));
            if (cb) {
                cb(null);
            }
        });
};

const deleteAssetInProgress = () => {
    return {
        type: ASSET_DELETE_IN_PROGRESS,
    };
};

const deleteAssetSuccess = (message) => {
    return {
        type: ASSET_DELETE_SUCCESS,
        message,
        variant: 'success',
    };
};

const deleteAssetError = (message) => {
    return {
        type: ASSET_DELETE_ERROR,
        message,
        variant: 'error',
    };
};

export const deleteAsset = (id, cb) => (dispatch) => {
    dispatch(deleteAssetInProgress());

    const url = urlAssetFetch(id);
    Axios.delete(url, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem('acToken_of_studio'),
        },
    })
        .then((res) => {
            dispatch(deleteAssetSuccess('Asset Deleted Successfully'));
            cb(null);
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(deleteAssetError(message));
            cb(error);
        });
};

export const showUploadFilesDialog = () => {
    return {
        type: UPLOAD_FILES_DIALOG_SHOW,
    };
};

export const hideUploadFilesDialog = () => {
    return {
        type: UPLOAD_FILES_DIALOG_HIDE,
    };
};

export const setUploadFileValid = () => {
    return {
        type: UPLOAD_FILE_ERROR_MESSAGE_SET,
    };
};

export const setCancelUpload = (list) => {
    return {
        type: UPLOAD_FILE_CANCEL_SET,
        list,
    };
};

export const setAssetUpload = (value, list) => {
    return {
        type: ASSET_UPLOAD_SET,
        value,
        list,
    };
};

const uploadAssetInProgress = () => {
    return {
        type: ASSET_UPLOAD_IN_PROGRESS,
    };
};

const uploadAssetSuccess = (data, id) => {
    return {
        type: ASSET_UPLOAD_SUCCESS,
        message: 'Uploaded',
        id,
    };
};

const uploadAssetError = (message) => {
    return {
        type: ASSET_UPLOAD_ERROR,
        message,
        variant: 'error',
    };
};

const setUploadProgress = (value, ID) => {
    return {
        type: ASSET_UPLOAD_PROGRESS_SET,
        value,
        ID,
    };
};

export const uploadAssetCancel = (cancel, ID) => {
    return {
        type: ASSET_UPLOAD_CANCEL_SET,
        cancel,
        ID,
    };
};

export const uploadAsset = (id, file, ID, cb) => (dispatch) => {
    dispatch(uploadAssetInProgress());

    const CancelToken = Axios.CancelToken;
    const formData = new FormData();
    formData.append('_type', getAssetType(file.type));
    formData.append('file', file);

    const url = urlUploadAsset(id);
    Axios.post(url, formData, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem('acToken_of_studio'),
        },
        onUploadProgress: (progressEvent) => {
            dispatch(setUploadProgress(progressEvent, ID));
        },
        cancelToken: new CancelToken((cancel) => {
            dispatch(uploadAssetCancel(cancel, ID));
        }),
    })
        .then((res) => {
            dispatch(uploadAssetSuccess(res.data && res.data.asset, ID));
            cb(null, res.data && res.data.asset);
        })
        .catch((error) => {
            const message = handleErrorMessage(error, 'Canceled File Upload!');
            dispatch(uploadAssetError(message));
            cb(error, null);
        });
};

export const reUploadAsset = (id, file, assetID, ID, cb) => (dispatch) => {
    dispatch(uploadAssetInProgress());

    const CancelToken = Axios.CancelToken;
    const formData = new FormData();
    formData.append('_type', getAssetType(file.type));
    formData.append('file', file);

    const url = urlReUploadAsset(id, assetID);
    Axios.post(url, formData, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem('acToken_of_studio'),
        },
        onUploadProgress: (progressEvent) => {
            dispatch(setUploadProgress(progressEvent, ID));
        },
        cancelToken: new CancelToken((cancel) => {
            dispatch(uploadAssetCancel(cancel, ID));
        }),
    })
        .then((res) => {
            dispatch(uploadAssetSuccess(res.data.result));
            cb(null);
        })
        .catch((error) => {
            const message = handleErrorMessage(error, 'Canceled File Upload!');
            dispatch(uploadAssetError(message));
            cb(error);
        });
};

const fetchTagsInProgress = () => {
    return {
        type: TAGS_FETCH_IN_PROGRESS,
    };
};

const fetchTagsSuccess = (value) => {
    return {
        type: TAGS_FETCH_SUCCESS,
        value,
    };
};

const fetchTagsError = (message) => {
    return {
        type: TAGS_FETCH_ERROR,
        message,
        variant: 'error',
    };
};

export const fetchTags = () => (dispatch) => {
    dispatch(fetchTagsInProgress());

    Axios.get(TAGS_URL, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem('acToken_of_studio'),
        },
    })
        .then((res) => {
            dispatch(fetchTagsSuccess(res.data && res.data.result));
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchTagsError(message));
        });
};

const fetchAssetCardsInProgress = () => {
    return {
        type: ASSET_CARDS_FETCH_IN_PROGRESS,
    };
};

const fetchAssetCardsSuccess = (value) => {
    return {
        type: ASSET_CARDS_FETCH_SUCCESS,
        value,
    };
};

const fetchAssetCardsError = (message) => {
    return {
        type: ASSET_CARDS_FETCH_ERROR,
        message,
        variant: 'error',
    };
};

export const fetchAssetCards = () => (dispatch) => {
    dispatch(fetchAssetCardsInProgress());

    Axios.get(ASSET_CARDS_URL, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem('acToken_of_studio'),
        },
    })
        .then((res) => {
            dispatch(fetchAssetCardsSuccess(res.data && res.data.result));
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchAssetCardsError(message));
        });
};

const fetchSchemaInProgress = () => {
    return {
        type: SCHEMA_FETCH_IN_PROGRESS,
    };
};

const fetchSchemaSuccess = (value) => {
    return {
        type: SCHEMA_FETCH_SUCCESS,
        value,
    };
};

const fetchSchemaError = (message) => {
    return {
        type: SCHEMA_FETCH_ERROR,
        message,
    };
};

export const fetchSchema = () => (dispatch) => {
    dispatch(fetchSchemaInProgress());

    Axios.get(SCHEMA_LIST_URL, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem('acToken_of_studio'),
        },
    })
        .then((res) => {
            dispatch(fetchSchemaSuccess(res.data && res.data.result));
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchSchemaError(message));
        });
};

export const setSchema = (value) => {
    return {
        type: SCHEMA_SET,
        value,
    };
};

const avatarUploadInProgress = () => {
    return {
        type: AVATAR_UPLOAD_IN_PROGRESS,
    };
};

const avatarUploadSuccess = (value) => {
    return {
        type: AVATAR_UPLOAD_SUCCESS,
        value,
    };
};

const avatarUploadError = (message) => {
    return {
        type: AVATAR_UPLOAD_ERROR,
        message,
        variant: 'error',
    };
};

export const avatarUpload = (file, cb) => (dispatch) => {
    dispatch(avatarUploadInProgress());

    const formData = new FormData();
    formData.append('file', file);

    Axios.post(AVATAR_UPLOAD_URL, formData, {
        headers: {
            Accept: 'application/json, text/plain, */*',
        },
    })
        .then((res) => {
            dispatch(avatarUploadSuccess(res.data));
            cb(res.data);
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(avatarUploadError(message));

            cb(null);
        });
};
